import { render } from "./CategoryView.vue?vue&type=template&id=61f61593&scoped=true&ts=true"
import script from "./CategoryView.vue?vue&type=script&lang=ts"
export * from "./CategoryView.vue?vue&type=script&lang=ts"

import "./CategoryView.vue?vue&type=style&index=0&id=61f61593&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f61593"]])

export default __exports__